import React, { Component } from "react";
import Sidebar6 from "../pages/Sidebar6";
import Header from "../layout/Header";
import BriefConversation from "../pages/BriefConversation";
import {
   Accordion,
   AccordionItem,
   AccordionItemHeading,
   AccordionItemButton,
   AccordionItemPanel,
} from "react-accessible-accordion";
import { Helmet } from "react-helmet";

export class BusinessProcessManagement extends Component {
   render() {
      const formtext = (
         <>
            <div className="formContentBox">
               <h1 className="hTitle1 formullimb">
                  Next steps:
               </h1>
               <p>Contact us today to schedule a strategic consultation. We’ll help you craft a tailored roadmap to evolve your marketing capabilities with Salesforce Marketing Cloud.</p>
            </div>
         </>
      );

      return (
         <>
         <Helmet>
            <title>Business Process Management - Thinqloud</title>
         </Helmet>

         <div className="site-main">
            <Header />
            <div className="ttm-page-title-row ttm-page-title-row63 ttmpagetitlerow5">
               <div className="container-xl">
                  <div className="row">
                     <div className="col-md-12">
                        <div className="title-box text-center">
                           <div className="page-title-heading">
                              <h2 className="title sh2">Business Process Management</h2>
                           </div>
                           <div className="breadcrumb-wrapper">
                              <span>
                                 <a title="Homepage" href={process.env.PUBLIC_URL + "/"}>
                                    <i className="ti ti-home" />
                                    &nbsp;&nbsp;Home
                                 </a>
                              </span>
                              <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                              <span>Business Process Management</span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

            <div className="sidebar ttm-sidebar ttm-bgcolor-white clearfix">
               <div className="container-xl">
                  <div className="row">
                     <div className="col-lg-9 content-area order-lg-2">
                        <div className="ttm-service-single-content-area">
                           <div className="section-title with-desc clearfix">
                              <div className="title-header">
                                 <h1 className="title h1TagTitle2">
                                    Drive Business Success with Expert  <span className="h1tagItalic">Salesforce
                                       Implementation</span>
                                 </h1>
                              </div>
                           </div>
                           <div className="ttm_single_image-wrapper mb-35">
                              <img className="img-fluid" src="/images/implementation-services1.png" />
                           </div>
                           <div className="ttm-service-description">
                              <p>
                                 At Thinqloud, we specialize in deploying tailored Salesforce solutions that seamlessly integrate with your existing business processes. Our expertise ensures your organization maximizes the value of Salesforce by streamlining workflows, enhancing data management, and enabling smarter decision-making. We work closely with your team to understand your unique needs, design customized configurations, and deliver scalable solutions that support your long-term growth. Partner with us to transform your operations and unlock the full potential of Salesforce.
                              </p>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="section-title with-desc clearfix">
                                 <div className="title-header">
                                    <h2 className="title">
                                       How to Prepare for Your <span>Salesforce Implementation</span>
                                    </h2>
                                 </div>
                              </div>
                              <ul className="ttm-list ttm-list-style-icon ulLi">
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Identify Key Stakeholders</strong>
                                       <p>Include members from sales, marketing, customer service, and IT teams to gather comprehensive insights.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont"> Clarify Business Goals</strong>
                                       <p>Define what success looks like for your Salesforce project — improved efficiency, better customer insights, increased sales, etc.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Set Up Stakeholder Meetings</strong>
                                       <p>Organize initial discussions to align expectations and gather input.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Gather Process Documentation</strong>
                                       <p>Collect existing workflows, process maps, and reports related to current operations.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Highlight Pain Points & Opportunities</strong>
                                       <p>Note current challenges and areas where automation or data visibility could help.</p>
                                    </span>
                                 </li>
                              </ul>
                              <p className="h5TagTitle">
                                 How We Identify<span> Processes to Digitize</span>
                              </p>
                              <ul className="ttm-list ttm-list-style-icon ulLi">
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Conduct a Business Process Review</strong>
                                       <p>We analyze your existing workflows to understand where manual work, redundancies, or bottlenecks exist.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Assess Automation Potential</strong>
                                       <p>We identify repetitive, rule-based tasks that can be automated within Salesforce to save time and reduce errors.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Prioritize Based on Impact</strong>
                                       <p>Processes that significantly improve productivity, data accuracy, or customer experience are prioritized for digitization.</p>
                                    </span>
                                 </li>
                                 <li>
                                    <i className="fa fa-check-circle ttm-textcolor-skincolor" />
                                    <span className="ttm-list-li-content">
                                       <strong className="strongFont">Map Processes to Salesforce Features</strong>
                                       <p>We design solutions that leverage Salesforce capabilities like automation, reporting, and integrations to address key needs.</p>
                                    </span>
                                 </li>
                              </ul>
                              <div className="separator">
                                 <div className="sep-line mt-35 mb-35 res-991-mtb-20" />
                              </div>
                              <div className="section-title with-desc clearfix mt-35">
                                 <div className="title-header">
                                    <h2 className="title">Frequently Asked Questions (FAQs)</h2>
                                 </div>
                              </div>
                              <Accordion>
                                 <AccordionItem>
                                    <AccordionItemHeading>
                                       <AccordionItemButton>
                                          <strong className="strongFont">Q1: How do I know if my business processes are suitable for Salesforce implementation?</strong>
                                       </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                       <p>
                                          A process is ideal for digitization if it is repetitive, involves multiple steps, and can benefit from automation, improved tracking, or better data visibility. During our assessment, we help identify these processes.
                                       </p>
                                    </AccordionItemPanel>
                                 </AccordionItem>
                                 <AccordionItem>
                                    <AccordionItemHeading>
                                       <AccordionItemButton>
                                          <strong className="strongFont">Q2: How can I prepare my team for Salesforce implementation?</strong>
                                       </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                       <p>
                                          Gather key stakeholders, existing process documentation, and reports. Be ready to share current workflows, pain points, and goals to help us customize a solution that fits your needs.
                                       </p>
                                    </AccordionItemPanel>
                                 </AccordionItem>
                                 <AccordionItem>
                                    <AccordionItemHeading>
                                       <AccordionItemButton>
                                          <strong className="strongFont">Q3: What kind of businesses do you work with?</strong>
                                       </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                       <p>
                                          We work with organizations of all sizes across various industries that want to optimize their operations and improve business processes through Salesforce.
                                       </p>
                                    </AccordionItemPanel>
                                 </AccordionItem>
                                 <AccordionItem>
                                    <AccordionItemHeading>
                                       <AccordionItemButton>
                                          <strong className="strongFont">Q4: How long does a typical implementation take?</strong>
                                       </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                       <p>
                                          Implementation timelines vary based on project scope but generally range from a few weeks to several months.
                                       </p>
                                    </AccordionItemPanel>
                                 </AccordionItem>
                                 <AccordionItem>
                                    <AccordionItemHeading>
                                       <AccordionItemButton>
                                          <strong className="strongFont">Q5: What kind of support do you provide post-implementation?</strong>
                                       </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                       <p>
                                          We offer ongoing support, training, and optimization services to ensure your Salesforce solution continues to meet your evolving business needs.
                                       </p>
                                    </AccordionItemPanel>
                                 </AccordionItem>
                              </Accordion>
                           </div>
                        </div>
                     </div>
                     <div className="col-lg-3 widget-area">
                        <Sidebar6 />
                     </div>
                  </div>
               </div>
            </div>
            <BriefConversation formtext={formtext} />
         </div>
         </>
      );
   }
}

export default BusinessProcessManagement;
